<template>
  <div>
    <el-row>
      <el-button
        type="success"
        size="small"
        @click="currentConfig = 'customer_name';configDialogVisible = true"
      >客户配置</el-button>
      <el-button type="success" size="small" @click="currentConfig = 'supplier';configDialogVisible = true">供应商配置</el-button>
      <el-button type="success" size="small" @click="currentConfig = 'operator';configDialogVisible = true">操作员配置</el-button>
      <el-button type="success" size="small" @click="currentConfig = 'department';configDialogVisible = true">生产单位配置</el-button>
      <el-button type="success" size="small" @click="currentConfig = 'face';configDialogVisible = true">表面处理配置</el-button>
      <el-button type="success" size="small" @click="currentConfig = 'process';configDialogVisible = true">加工步骤配置</el-button>
    </el-row>
    <el-dialog v-if="currentConfig !== 'process'" title="配置" :visible.sync="configDialogVisible" width="700px" @close="currentConfig = ''">
      <el-popover @show="sort = idx +1" @hide="sortChange(idx,tag)" trigger="click" placement="top" v-for="(tag,idx) in currentList" :key="tag" class="popoverContainer" popper-class="configPagePopover">
      <el-input-number v-model="sort"  :min="1" :max="currentList.length" label="序号" size="small"></el-input-number>
      <el-tag
        style="cursor:pointer"
        slot="reference"
        closable
        @close="currentList.splice(idx,1)"
      >{{tag}}</el-tag>
      </el-popover>
      <el-input
        class="input-new-tag"
        v-if="inputVisible"
        v-model="inputValue"
        ref="saveTagInput"
        size="small"
        @keyup.enter.native="handleInputConfirm"
        @blur="handleInputConfirm"
      ></el-input>
      <el-button v-else class="button-new-tag" size="small" @click="inputVisible = true">+ 增加</el-button>

      <span slot="footer">
        <el-button size="small" @click="configDialogVisible=false">取消</el-button>
        <el-button size="small" type="primary" @click="submit">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="currentConfig === 'process'" title="配置" :visible.sync="configDialogVisible" width="900px" @close="currentConfig = ''">
      <el-button class="button-new-tag" size="small" @click="showProcessAdd">+ 增加</el-button>
      <el-table
        :data="processConfigTableData.filter(data => !processConfigTableSearch || data.process.includes(processConfigTableSearch))"
        style="width: 100%"
        max-height="500">
        <el-table-column
          prop="process"
          label="步骤"
          align="center">
        </el-table-column>
        <el-table-column
          prop="price"
          label="单价"
          align="center">
        </el-table-column>
        <el-table-column
          align="center">
          <template slot="header" slot-scope="scope">
            <el-input
              v-model="processConfigTableSearch"
              clearable
              size="mini"
              :other="scope"
              placeholder="输入步骤关键字搜索"/>
          </template>
          <template slot-scope="scope">
            <el-link type="primary" @click.stop="showProcessEdit(scope.row)">编辑</el-link>
            <el-divider direction="vertical"></el-divider>
            <el-link slot="reference" type="primary" @click="onDeleteProcess(scope.row.id)">删除</el-link>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer">
        <el-button size="small" @click="configDialogVisible=false">取消</el-button>
        <el-button size="small" type="primary" @click="submit">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog v-if="currentConfig === 'process'" :title="processInputDialogTitle" :visible.sync="processInputDialogVisible" width="500px" @close="currentProcessInfo={process: '',price: ''}">
      <div style="display: flex;flex-direction: column;justify-content: center;align-items: center">
        <el-input style="width:200px" placeholder="步骤" v-model="currentProcessInfo.process" size="small"></el-input>
        <el-input style="width:200px;margin-top:10px" placeholder="单价" v-model="currentProcessInfo.price" size="small"></el-input>
      </div>
      <span slot="footer">
        <el-button size="small" @click="processInputDialogVisible=false;currentProcessInfo={process: '',price: ''}">取消</el-button>
        <el-button size="small" type="primary" @click="processInputOK">确认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getConfig, setConfig } from '../api/index'
export default {
  data () {
    return {
      configDialogVisible: false,
      configOptions: {},
      currentConfig: '',
      currentList: [],
      inputVisible: false,
      inputValue: '',
      sort: '',
      processConfigTableData: [],
      processConfigTableSearch: '',
      currentProcessInfo: {
        process: '',
        price: ''
      },
      processInputDialogVisible: false,
      processInputDialogTitle: '增加步骤'
    }
  },
  watch: {
    currentConfig: function (val) {
      if (val === '') {
        this.currentList = []
      } else {
        let configList = []
        configList = this.configOptions[val].split(',')
        if (configList.length === 1 && configList[0] === '') {
          configList = []
        }
        this.currentList = configList
        if (val === 'process') {
          this.processConfigTableData = configList.map((item, index) => {
            const currentProcessInfo = item.split(':')
            return {
              id: index,
              process: currentProcessInfo[0],
              price: currentProcessInfo[1]
            }
          })
        }
      }
    }
  },
  mounted () {
    this.getConfig()
  },
  methods: {
    showProcessAdd () {
      this.processInputDialogVisible = true
      this.processInputDialogTitle = '增加步骤'
    },
    showProcessEdit (rowData) {
      this.processInputDialogVisible = true
      this.currentProcessInfo = JSON.parse(JSON.stringify(rowData))
      this.processInputDialogTitle = '编辑步骤'
    },
    processInputOK () {
      if (this.currentProcessInfo.id || this.currentProcessInfo.id === 0) {
        let currentProcessInfo = this.processConfigTableData.find(item => item.id === this.currentProcessInfo.id)
        currentProcessInfo.process = this.currentProcessInfo.process
        currentProcessInfo.price = this.currentProcessInfo.price
      } else {
        this.processConfigTableData.push({
          id: this.processConfigTableData.length,
          process: this.currentProcessInfo.process,
          price: this.currentProcessInfo.price
        })
      }
      this.processInputDialogVisible = false
      this.currentProcessInfo = {
        process: '',
        price: ''
      }
    },
    onDeleteProcess (id) {
      const currentIndex = this.processConfigTableData.findIndex(item => item.id === id)
      this.processConfigTableData.splice(currentIndex, 1)
    },
    handleInputConfirm () {
      let inputValue = this.inputValue.trim()
      if (inputValue) {
        this.currentList.push(inputValue)
      }
      this.inputVisible = false
      this.inputValue = ''
    },
    submit () {
      let value = ''
      if (this.currentConfig === 'process') {
        value = this.processConfigTableData.map(item => {
          let itemValue = ''
          if (item.price) {
            itemValue = item.process + ':' + item.price
          } else {
            itemValue = item.process
          }
          return itemValue
        }).join(',')
      } else {
        value = this.currentList.join(',')
      }
      let params = {
        config_name: this.currentConfig,
        value
      }
      setConfig(params).then(res => {
        if (res.data.status === 200) {
          this.$message.success(res.data.msg)
          this.configDialogVisible = false
          this.getConfig()
          this.$store.dispatch('getLoginInfo')
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getConfig () {
      getConfig().then(res => {
        if (res.data.status === 200) {
          this.configOptions = res.data.data
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    sortChange (index, tag) {
      // console.log(sort)
      let target = this.currentList[this.sort - 1]
      this.currentList.splice(this.sort - 1, 1, tag)
      this.currentList.splice(index, 1, target)
    }
  }
}
</script>

<style scoped>
.el-tag{
  margin-bottom: 10px
}
.popoverContainer + .popoverContainer{
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 200px;
  margin-left: 10px;
  vertical-align: bottom;
  margin-bottom: 10px;
}
</style>
<style>
.configPagePopover{
  text-align: center;
}
</style>
